import { PersistQueryClientProvider } from '@tanstack/react-query-persist-client';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { RouterProvider } from 'react-router';
import './index.css';
import { InstallPrompt } from './components/install-prompt';
import { OfflineChip } from './components/offline-chip';
import { installErrorReporter } from './lib/install-error-reporter';
import { PERSIST_OPTIONS, createPersister, createQueryClient } from './lib/query-client';
import { installServiceWorker } from './lib/sw-register';
import { router } from './router';

installErrorReporter();
installServiceWorker();

const rootElement = document.querySelector('#root');
if (!rootElement) {
  throw new Error('Root element not found. Expected a <div id="root" /> in index.html.');
}

const queryClient = createQueryClient();
const persister = createPersister();

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <PersistQueryClientProvider
      client={queryClient}
      persistOptions={{ persister, ...PERSIST_OPTIONS }}
    >
      <OfflineChip />
      <InstallPrompt />
      <RouterProvider router={router} />
    </PersistQueryClientProvider>
  </React.StrictMode>,
);
